import { useContext, useEffect } from "react";
import { Table } from "react-bootstrap";
import { DateInput } from "react-hichestan-datetimepicker";
import { isEmpty } from "lodash";

import Breadcrumbs from "../../../utils/Breadcrumbs/Breadcrumbs";
import SiteTitle from "../../../utils/SiteTitle/SiteTitle";
import EmptyData from "../../../utils/EmptyData/EmptyData";
import CardLayout from "../../../utils/CardLayout/CardLayout";
import PaginationList from "../../../utils/PaginationList/PaginationList";
import TooltipTitle from "../../../utils/TooltipTitle/TooltipTitle";
import { logAdminContext } from "../../../context/Admin/LogAdminContext/LogAdminContext";
import { convertDate, dialogContainerStyle } from "../../../utils";

const LogAdmin = () => {
  const {
    logs,
    id,
    setId,
    limit,
    setLimit,
    totalCount,
    pageNumber,
    setPageNumber,
    to_date,
    setTo_date,
    from_date,
    setFrom_date,
    handleGetLogsList,
  } = useContext(logAdminContext);

  useEffect(() => {
    handleGetLogsList();
  }, [pageNumber, limit]);

  return (
    <>
      <SiteTitle title="گزارشات" />
      <Breadcrumbs
        navs={[
          { name: "داشبورد", url: "/Admin/Dashboard", type: "l" },
          { name: "گزارشات", type: "a" },
        ]}
        title="لیست گزارشات"
      />

      <CardLayout>
        <form className="input-group mb-3" onSubmit={handleGetLogsList}>
          <input
            type="number"
            name="search"
            autoComplete="off"
            placeholder="شماره سفارش ..."
            className="form-control"
            value={id}
            onChange={(e) => setId(e.target.value)}
          />
          <div className="input-group-append">
            <button type="submit" className="btn btn-primary">
              جستجو
            </button>
          </div>
        </form>

        <div className="row">
          <div className="col-12 col-md-6 col-lg-3 mb-2">
            <TooltipTitle title="از تاریخ">
              <DateInput
                id="from_date"
                value={from_date}
                className="form-control"
                name="from_date"
                onChange={(e) => setFrom_date(e.target.value)}
                autoOk="false"
                placeholder="از تاریخ"
                dialogContainerStyle={dialogContainerStyle}
              />
            </TooltipTitle>
          </div>
          <div className="col-12 col-md-6 col-lg-3 mb-2">
            <TooltipTitle title="تا تاریخ">
              <DateInput
                id="to_date"
                value={to_date}
                className="form-control"
                name="to_date"
                onChange={(e) => setTo_date(e.target.value)}
                autoOk="false"
                placeholder="تا تاریخ"
                dialogContainerStyle={dialogContainerStyle}
              />
            </TooltipTitle>
          </div>
        </div>

        {isEmpty(logs) ? (
          <EmptyData />
        ) : (
          <>
            <div className="d-flex justify-content-between align-items-center">
              <PaginationList
                setPageNumber={setPageNumber}
                pageCount={totalCount / limit}
              />
              <div>
                <select
                  className="form-control mb-3"
                  onChange={(e) => setLimit(Number(e.target.value))}
                >
                  <option value={10} selected={10 === limit}>
                    10
                  </option>
                  <option value={25} selected={25 === limit}>
                    25
                  </option>
                  <option value={50} selected={50 === limit}>
                    50
                  </option>
                  <option value={75} selected={75 === limit}>
                    75
                  </option>
                  <option value={100} selected={100 === limit}>
                    100
                  </option>
                </select>
              </div>
            </div>
            <Table responsive hover borderless striped>
              <thead className="thead-dark">
                <tr>
                  <th>#</th>
                  <th>کاربر</th>
                  <th>شماره سفارش</th>
                  <th>تاریخ ایجاد</th>
                  <th>زمان اجرا</th>
                  <th>توضیحات</th>
                  <th className="text-center">
                    تعداد کل :{" "}
                    <span className="badge badge-primary font-weight-bold p-1">
                      {totalCount}
                    </span>
                  </th>
                </tr>
              </thead>
              <tbody>
                {logs.map((_item, index) => (
                  <tr>
                    <td>{index + 1}</td>
                    <td>{_item.user}</td>
                    <td>{_item.order}</td>
                    <td>{convertDate(_item.created)}</td>
                    <td>{_item.action_time}</td>
                    <td>{_item.change_message}</td>
                    <td className="mw-25"></td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </>
        )}
      </CardLayout>
    </>
  );
};

export default LogAdmin;
